import axios from "../axios";

export const getUsers = () => {
  return axios.get("dashboard/users");
};

export const getUser = (userId) => {
  return axios.get(`dashboard/users/${userId}`);
};
